export const CONFIGURATOR = {
    DOCUMENT: 'document',
} as const;

export type ConfiguratorEnum = Enum<typeof CONFIGURATOR>;
